import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Shop from "../pages/shop/page";
import ProductDetail from "../pages/product/page";
import About from "../pages/about/page";
import Cart from "../pages/cart/page";
import CollectionsIndex, { CollectionDetail } from "../pages/collections/page";
import Care from "../pages/care/page";
import FAQ from "../pages/faq/page";
import Contact from "../pages/contact/page";
import Journal from "../pages/journal/page";
import { Shipping, Privacy, Terms } from "../pages/info/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/shop", element: <Shop /> },
  { path: "/product/:slug", element: <ProductDetail /> },
  { path: "/collections", element: <CollectionsIndex /> },
  { path: "/collections/:slug", element: <CollectionDetail /> },
  { path: "/about", element: <About /> },
  { path: "/cart", element: <Cart /> },
  { path: "/shipping", element: <Shipping /> },
  { path: "/care", element: <Care /> },
  { path: "/faq", element: <FAQ /> },
  { path: "/contact", element: <Contact /> },
  { path: "/journal", element: <Journal /> },
  { path: "/privacy", element: <Privacy /> },
  { path: "/terms", element: <Terms /> },
  { path: "*", element: <NotFound /> },
];

export default routes;